import { Container, Typography } from "@material-ui/core";
import logo from "../assets/logo_full.png";

const TerminosCondicionesPage = () => {
  return (
    <>
      <Container maxWidth="md">
        <center>
          <img src={logo} alt="nec" />
        </center>
        <Typography variant="h4">Terminos y Condiciones</Typography>
        <br />
        <Typography variant="h6">1. Introducción</Typography>
        <br />
        <Typography variant="body1">
          Esta política de privacidad describe cómo{" "}
          <strong>CRM NAVECUADOR</strong> recopila, utiliza y comparte su
          información personal cuando accede a nuestra aplicación movil o
          utiliza nuestros servicios.
        </Typography>
        <br />
        <Typography variant="h6">2. Información que recopilamos</Typography>
        <br />
        <Typography variant="body1">
          Podemos recopilar varios tipos de información personal de usted,
          incluyendo:
        </Typography>
        <br />
        <Typography variant="body1">
          <strong>Información que nos proporciona:</strong> Recopilamos
          información que usted nos proporciona directamente, como su nombre,
          dirección de correo electrónico e información de contacto.
          <br />
        </Typography>
        <br />
        <Typography variant="h6">3. Cómo utilizamos su información</Typography>
        <br />
        <Typography>
          Utilizamos su información personal para los siguientes fines:
          <br /> <br />
          <li>Para proporcionarle nuestros servicios y productos.</li>
          <li>
            Para comunicarnos con usted sobre nuestros servicios y productos.
          </li>{" "}
          <li>Para personalizar su experiencia con nuestros servicios.</li>
        </Typography>
        <br />
        <Typography variant="h6">4. Compartir su información</Typography>
        <br />
        <Typography variant="body1">
          Podemos compartir su información personal con los siguientes terceros:
          <br />
          <br />
          <strong>Nuestros proveedores de servicios:</strong> Podemos compartir
          su información personal con nuestros proveedores de servicios que nos
          ayudan a proporcionar nuestros servicios y productos.
          <br />
          <strong>Socios comerciales:</strong> Podemos compartir su información
          personal con nuestros socios comerciales que nos ayudan a
          comercializar nuestros servicios y productos.
          <br /> <strong>Autoridades gubernamentales:</strong> Podemos compartir
          su información personal con autoridades gubernamentales si así lo
          exige la ley.
        </Typography>
        <br />
        <Typography variant="h6">5. Cómo contactarnos</Typography>
        <br />
        <Typography variant="body1">
          Si tiene alguna pregunta o inquietud sobre esta Política, puede
          contactarnos directamente con el area de IT.
        </Typography>
        <br />
        <Typography variant="h6">6. Actualizaciones a esta Política</Typography>
        <br />
        <Typography variant="body1">
          Podemos actualizar esta Política de vez en cuando. La versión más
          reciente de la Política se publicará en nuestro sitio web.
        </Typography>
      </Container>
    </>
  );
};

export default TerminosCondicionesPage;
